import { IntegrationProvider, ProviderKind } from '@/types/integrations.ts';

export function isStandaloneCapabilityProvider(provider?: IntegrationProvider): boolean {
  if (!provider) return false;
  if (provider?.provider_kind) {
    return provider.provider_kind === ProviderKind.StandaloneCapability;
  }
  return provider.is_step_type;
}

export function isSystemIntegrationProvider(provider?: IntegrationProvider): boolean {
  if (!provider) return false;
  if (provider?.provider_kind) {
    return provider.provider_kind === ProviderKind.SystemIntegration;
  }
  return provider.internal_integration && !isStandaloneCapabilityProvider(provider);
}

export function isExternalIntegrationProvider(provider?: IntegrationProvider): boolean {
  if (!provider) return false;
  if (provider?.provider_kind) {
    return provider.provider_kind === ProviderKind.ExternalIntegration;
  }
  return !provider.internal_integration && !isStandaloneCapabilityProvider(provider);
}

export function providerUsesIntegrationInstance(provider?: IntegrationProvider): boolean {
  return isExternalIntegrationProvider(provider);
}

export function isSharePointProvider(provider?: IntegrationProvider): boolean {
  return provider?.name === 'sharepoint-online';
}
